import React from 'react';
import { Menu, MenuItem, SxProps, Theme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { useAppSelector } from 'hooks';
import { AuthManager } from 'models';
import { hasRole } from 'utils';

interface AccountMenuProps {
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    paperSx?: SxProps<Theme>;
}

const AccountMenu: React.FunctionComponent<AccountMenuProps> = ({
    anchorEl,
    open,
    onClose,
    paperSx,
}) => {
    const auth = useAppSelector((s) => s.auth);

    const canSeeUserManager = hasRole(
        auth.user.object,
        'Project Manager',
        'Project Admin',
        'BMC Support',
        'BMC Executive Officer',
    );

    const onLogout = () => {
        onClose();
        AuthManager.logout();
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            slotProps={paperSx ? { paper: { sx: paperSx } } : undefined}
        >
            {canSeeUserManager && (
                <MenuItem
                    component={RouterLink}
                    to="/admin/users"
                    onClick={onClose}
                >
                    User Manager
                </MenuItem>
            )}
            <MenuItem
                component={RouterLink}
                to="/layers/metadata"
                onClick={onClose}
            >
                Layer Metadata
            </MenuItem>
            <MenuItem component={RouterLink} to="/user/self" onClick={onClose}>
                My Details
            </MenuItem>
            <MenuItem
                onClick={onLogout}
                disabled={auth.tokens.status !== 'finished'}
            >
                Logout
            </MenuItem>
        </Menu>
    );
};

export default AccountMenu;
